export class ReportError extends Error {}
